/**
 *
 * A service to detect the current geolocation of the user devices
 * Right now only used by native mobile
 *
 * */

import Service from 'react-reservice';

import { IGeolocation, geolocationApi } from '@webtrader/core/api/config/geolocation';

import { configService } from '../config';
import debugLogService from '../debug-log';

const MAX_RETRY_COUNT = 3;
const RETRY_DELAY_MS = 500;

interface IGeolocationContext {
  geolocation: IGeolocation;
  isLoadingGeolocation: boolean;
  isChina: boolean;
}

const defaultContext: IGeolocationContext = {
  geolocation: {
    ipAddress: '',
    provider: '',
    country: '',
    forwardedIP: '',
    remoteAddr: ''
  },
  isLoadingGeolocation: true,
  isChina: false
};

class GeolocationService extends Service<IGeolocationContext> {
  private retryCount = 0;

  constructor() {
    super();
    this.context = {
      ...defaultContext
    };
  }

  public init = async () => {
    await this.retriveGeolocation();
  };

  private retriveGeolocation = async () => {
    try {
      const { result } = await geolocationApi.getGeolocation();

      if (result) {
        this.context.geolocation = result;
        if (result.country === 'CN') {
          this.context.isChina = true;
          configService.switchToFallbackDomain(); // Use fallback domain (for Hantec , it should be webtrader.hmarkets.cn)
        } else {
          this.context.isChina = false;
        }
        debugLogService.log('Geolocation', 'success');
      }
      this.context.isLoadingGeolocation = false;
    } catch (error) {
      this.retryCount = this.retryCount + 1;
      if (this.retryCount < MAX_RETRY_COUNT) {
        setTimeout(() => {
          this.retriveGeolocation();
        }, RETRY_DELAY_MS);
      } else {
        this.context.isLoadingGeolocation = false;
        debugLogService.log('Geolocation', 'error', error);
      }
    }
  };

  public getCurrentGeolocation = () => {
    return this.context.geolocation;
  };

  public getIsChina = () => {
    return this.context.isChina;
  };
}

const geolocationService = new GeolocationService();
export default geolocationService;
